<template>
	<div>
		<nav>
			<div class="nav nav-tabs" id="nav-tab" role="tablist">
			<button class="nav-link active" id="nav-home-tab" data-toggle="tab" data-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Download</button>
			<button class="nav-link" id="nav-profile-tab" data-toggle="tab" data-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Figures</button>
			<button class="nav-link" id="nav-contact-tab" data-toggle="tab" data-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Supplementary Materials</button>
			</div>
		</nav>
		<div class="tab-content" id="nav-tabContent">
			<div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style="margin-top: 10px;">
				<div v-if="files.length" v-for="(file, index) in files">
					<a href="javascript:void(0)" v-on:click="popupAttachment(file.url)" class="mb-3">{{ file.title }}</a>
				</div>
				<div v-if="!files.length" >
					No record
				</div>
			</div>
			<div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab" style="margin-top: 10px;">No record</div>
			<div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab" style="margin-top: 10px;">No record</div>
		</div>
	</div>
</template>


<script>
	export default {
	    props: ['data'],
	    data() {
	        return {
	        	files: [],
	        };
	    },
	    mounted() {
	        this.getPostAttachments(this.data.post_id);
	    },    
	    methods: {
	    	getPostAttachments(id) {
	    	    const form = new FormData();
	    	    form.append('id', id);
	    	    axios.post('/api/ajax/posts/attachments', form)
	    	    .then(res => {
                    this.files = res.data.data.files;	    	        
	    	    })
	    	    .catch(err => {  
	    	        console.log(err);                  
	    	    });
	    	},
	    	popupAttachment(url) {
	    	    const form = new FormData();
	    	    form.append('type', 'file');
	    	    form.append('post_id', this.data.post_id);
	    	    axios.post('/api/ajax/posts/hit', form)
	    	    .then(res => {
	    	        const link = document.createElement('a');
	    	        link.href = url;
	    	        link.setAttribute('target', '_blank');
	    	        document.body.appendChild(link);
	    	        link.click();
	    	    })
	    	    .catch(err => {  
	    	        console.log(err);                  
	    	    }); 
	    	},
	    },       
	}	

</script>


